import { useSelector } from 'react-redux';

export const useTemplateFontSettings = () => {
    const fontSettings = useSelector((state) => state.meeting.fontSettings);

    const {
        baseFontSize,
        avatarSize,
        iconFontSize,
        smallTitleSize,
        smallFontSize,
        titleSize,
        itemSize,
        agendaFontSize,
        titleFontSize,
        attechmentTableFontSize,
        lineHeight,
        chipFontSize,
    } = fontSettings;


    const tableCellStyle = {
        fontSize: baseFontSize,
        ...(lineHeight && { lineHeight: lineHeight })
    };

    const listItemStyle = {
        '&:hover .ListItemIcons': { opacity: 1 },
        justifyContent: 'center',
        padding: 0,
        fontSize: baseFontSize,
        ...(lineHeight && { lineHeight })
    };

    const fabStyle = {
        width: avatarSize,
        height: avatarSize,
        minHeight: avatarSize,
        '& .MuiSvgIcon-root': {
            fontSize: `calc(${avatarSize} * 0.6)`
        }
    };

    const smallfabStyle = {
        width: '20px',
        height: '20px',
        '& .MuiSvgIcon-root': {
            fontSize: `calc(${20} * 0.6)`
        }
    };



    const paginationStyle = {
        '& .MuiTablePagination-root': {
            fontSize: baseFontSize,
            ...(lineHeight && { lineHeight })
        },
        '& .MuiTablePagination-selectLabel': {
            fontSize: baseFontSize,
            ...(lineHeight && { lineHeight })
        },
        '& .MuiTablePagination-displayedRows': {
            fontSize: baseFontSize,
            ...(lineHeight && { lineHeight })
        },
        '& .MuiTablePagination-select': {
            fontSize: baseFontSize,
            ...(lineHeight && { lineHeight })
        }
    };

    const buttonStyle = {
        minWidth: iconFontSize,
        p: '1px'
    };

    const dshReviewBackgroundcolor = "#E5F3FD";
    const dshVoteBackgroundcolor = "#E8ECE4";
    const dshVideoBackgroundcolor = "#FFF0F5";
    const dshPreviousBackgroundcolor = "#FFF3E0";

    const dshReviewChip = '#3F88C5';
    const dshVoteChip = '#5A8F57';
    const dshVideoChip = '#c2185b';
    const dshPreviousChip = '#F57C00';


    return { baseFontSize, smallTitleSize, smallFontSize, lineHeight, chipFontSize, titleSize, tableCellStyle, paginationStyle, buttonStyle, listItemStyle, fabStyle, iconFontSize, itemSize, agendaFontSize, titleFontSize, attechmentTableFontSize, dshReviewBackgroundcolor, dshVoteBackgroundcolor, dshVideoBackgroundcolor, dshPreviousBackgroundcolor, dshReviewChip, dshVoteChip, dshVideoChip, dshPreviousChip };
};